//
// The Yoast FAQ specific JavaScript
//
const faqAccordion = document.getElementsByClassName('section-faqs--accordion');
const faqBlock = document.getElementsByClassName('wp-block-yoast-faq-block');
if (faqAccordion) {
	if (faqBlock.length !== 0) {
		const allQuestions = document.querySelectorAll('.wp-block-yoast-faq-block .schema-faq-section');

		allQuestions.forEach(question => {
			question.querySelector('.schema-faq-question').addEventListener('click', function () {
				const parent = this.parentElement;
				if (parent.classList.contains('open')) {
					parent.classList.remove('open');
				} else {
					allQuestions.forEach(question => {
						question.classList.remove('open');
					});
					parent.classList.add('open');
				}
			});
		});
	}
}
